// design-areas.js - Print box definitions and helper functions for the customizer
// Box definitions are read from ProductConfig so new products need config only.

(function(window) {
  'use strict';

  // Read hoodie box definitions from ProductConfig (single source of truth)
  var hoodieCfg = window.ProductConfig.getProduct("hoodie");
  var hoodieBoxes = hoodieCfg.boxes;

  // Exported box references (backward compat - same property names as before)
  var FRONT_BOX = hoodieBoxes.front;
  var BACK_TOP = hoodieBoxes.back_top;
  var BACK_MIDDLE = hoodieBoxes.back_middle;
  var BACK_BOTTOM = hoodieBoxes.back_bottom;
  var HOOD_LEFT_BOX = hoodieBoxes.hood_left;
  var HOOD_RIGHT_BOX = hoodieBoxes.hood_right;

  // Composite back box (union of back_top through back_bottom)
  var BACK_BOX = {
    x: BACK_TOP.x,
    y: BACK_TOP.y,
    width: BACK_TOP.width,
    height: (BACK_BOTTOM.y + BACK_BOTTOM.height) - BACK_TOP.y
  };

  // Track highlighted box for visual feedback
  var HIGHLIGHT_BOX = null;

  // Canvas zoom configurations for each area
  function getZoomConfig(box, scale) {
    if (!box) return { scale: 1, translateX: 0, translateY: 0 };
    return {
      scale: scale,
      translateX: -((box.x + box.width / 2) - 350) * scale,
      translateY: -((box.y + box.height / 2) - 350) * scale
    };
  }

  // Hood boxes zoom as ONE combined region (never per-side). Maps each hood box
  // to its partner; the zoom target is the union of the pair.
  var HOOD_PAIR = {
    hood_left: "hood_right",
    hood_right: "hood_left",
    back_hood_left: "back_hood_right",
    back_hood_right: "back_hood_left"
  };
  var HOOD_PAIR_SCALE = 1.5;

  // Zoom config for a box on a product config, unifying hood pairs.
  // Falls back to reset (scale 1) when the box has no zoomScales entry.
  function getBoxZoomConfig(productConfig, boxName) {
    if (!productConfig || !boxName || !productConfig.boxes) return getZoomConfig(null, 1);
    var box = productConfig.boxes[boxName];
    if (!box) return getZoomConfig(null, 1);
    var pairName = HOOD_PAIR[boxName];
    var pairBox = pairName ? productConfig.boxes[pairName] : null;
    if (pairBox) {
      var ux = Math.min(box.x, pairBox.x);
      var uy = Math.min(box.y, pairBox.y);
      var ur = Math.max(box.x + box.width, pairBox.x + pairBox.width);
      var ub = Math.max(box.y + box.height, pairBox.y + pairBox.height);
      return getZoomConfig({ x: ux, y: uy, width: ur - ux, height: ub - uy }, HOOD_PAIR_SCALE);
    }
    var scale = productConfig.zoomScales && productConfig.zoomScales[boxName];
    if (!scale) return getZoomConfig(null, 1);
    return getZoomConfig(box, scale);
  }

  // Build zoom configs from ProductConfig for the hoodie
  var ZOOM_CONFIGS = window.ProductConfig.getZoomConfigs("hoodie", getZoomConfig);
  // Add legacy aliases used by the mousedown handler
  ZOOM_CONFIGS.back = ZOOM_CONFIGS.back_top;
  ZOOM_CONFIGS.teamwall = ZOOM_CONFIGS.back_middle;
  // Hood entries zoom to the combined hood region on every trigger
  ZOOM_CONFIGS.hood_left = getBoxZoomConfig(hoodieCfg, "hood_left");
  ZOOM_CONFIGS.hood_right = getBoxZoomConfig(hoodieCfg, "hood_right");

  // Track current zoom state
  var CURRENT_ZOOM = null;

  // Padding per box - reads from config's pad field
  function getPadForBox(boxName) {
    var activeId = window.ProductConfig.getActiveProductId();
    var box = window.ProductConfig.getBoxByName(activeId, boxName);
    if (box && typeof box.pad === "number") return box.pad;
    return 10; // fallback default
  }

  // Get current active box based on CURRENT_INDEX
  function getCurrentBox() {
    return window.CURRENT_INDEX === 0 ? FRONT_BOX : BACK_BOX;
  }

  // Check if a point is inside a box
  function pointInBox(x, y, box) {
    return (x >= box.x && x < box.x + box.width &&
      y >= box.y && y < box.y + box.height);
  }

  // Check if a box has any content
  function boxHasContent(partIndex, boxName) {
    var items = window.ACTIVE_ITEMS || window.DESIGN_ITEMS;
    if (!items) return false;

    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it.show) continue;
      if (it.part_index === partIndex && it.boxName === boxName) return true;
    }
    return false;
  }

  // Set the highlight box for visual feedback
  function setHighlightBox(box) {
    HIGHLIGHT_BOX = box;
    if (window.DESIGN && window.DESIGN.drawImages) {
      window.DESIGN.drawImages();
    }
  }

  // Clear the highlight box
  function clearHighlightBox() {
    HIGHLIGHT_BOX = null;
    if (window.DESIGN && window.DESIGN.drawImages) {
      window.DESIGN.drawImages();
    }
  }

  // Apply zoom animation to canvas
  function applyCanvasZoom(zoomConfig, skipAnimation) {
    var createImage = document.querySelector('.createImage');
    if (!createImage) return;

    CURRENT_ZOOM = zoomConfig;

    if (!skipAnimation) {
      createImage.classList.add('zooming');
    }
    createImage.style.transform = `scale(${zoomConfig.scale}) translate(${zoomConfig.translateX / zoomConfig.scale}px, ${zoomConfig.translateY / zoomConfig.scale}px)`;

    if (!skipAnimation) {
      setTimeout(() => createImage.classList.remove('zooming'), 600);
    }
  }

  // Reapply current zoom (used after canvas updates)
  function maintainZoom() {
    if (CURRENT_ZOOM && CURRENT_ZOOM.scale !== 1) {
      applyCanvasZoom(CURRENT_ZOOM, true);
    }
  }

  // Helper to switch canvas mode with zoom
  function switchCanvasMode(partIndex, box, buttonId, zoomKey) {
    if (window.loadPart) {
      window.loadPart(partIndex);
    }
    setHighlightBox(box);
    if (window.setActiveMode) {
      window.setActiveMode(buttonId);
    }
    // Determine zoom source: use active product's zoom configs
    var activeId = window.ProductConfig.getActiveProductId();
    var zoomSource;
    if (activeId !== "hoodie") {
      // For non-base products, build zoom configs on the fly or use cached window.ZIP_ZOOM_CONFIGS
      zoomSource = window.ZIP_ZOOM_CONFIGS || window.ProductConfig.getZoomConfigs(activeId, getZoomConfig);
    } else {
      zoomSource = ZOOM_CONFIGS;
    }
    applyCanvasZoom(zoomSource[zoomKey] || ZOOM_CONFIGS.reset);
  }

  // Export to window for global access
  window.DesignAreas = {
    // Box definitions
    FRONT_BOX: FRONT_BOX,
    BACK_BOX: BACK_BOX,
    BACK_TOP: BACK_TOP,
    BACK_MIDDLE: BACK_MIDDLE,
    BACK_BOTTOM: BACK_BOTTOM,
    HOOD_LEFT_BOX: HOOD_LEFT_BOX,
    HOOD_RIGHT_BOX: HOOD_RIGHT_BOX,

    // Zoom configurations
    ZOOM_CONFIGS: ZOOM_CONFIGS,
    CURRENT_ZOOM: CURRENT_ZOOM,

    // Functions
    getZoomConfig: getZoomConfig,
    getBoxZoomConfig: getBoxZoomConfig,
    getPadForBox: getPadForBox,
    getCurrentBox: getCurrentBox,
    pointInBox: pointInBox,
    boxHasContent: boxHasContent,
    setHighlightBox: setHighlightBox,
    clearHighlightBox: clearHighlightBox,
    applyCanvasZoom: applyCanvasZoom,
    maintainZoom: maintainZoom,
    switchCanvasMode: switchCanvasMode,

    // Get current highlight box
    getHighlightBox: function() {
      return HIGHLIGHT_BOX;
    },

    // Set current zoom directly
    setCurrentZoom: function(zoom) {
      CURRENT_ZOOM = zoom;
    },

    // Get current zoom
    getCurrentZoom: function() {
      return CURRENT_ZOOM;
    }
  };

})(window);
